import React, { Fragment, useState,useEffect,useContext} from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import FQuickAccessList from "../../components/FQuickAccessList/FQuickAccessList";
import { useLocation } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { useProcessor } from "../../hooks/useProcessor";
import Moment from 'moment';
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";
//import { useRequest } from "../../hooks/useRequest";

const BankPaymentScreen = ({ param }) => {

  
    const { processPayment } = useProcessor();
    const [ref, setRef] = useState('0000')
    const [cie, setCIE] = useState('0000')
    const [deadline, setDeadLine] = useState('')
    const route = useNavigate();
    const {state} = useLocation()
    const {setAlert} = useContext(AuthContext)

    useEffect(() => {

        const nextScreen = async () => {
            const data = {
                originCurrencyId: state.originCurrency,
                destinationCurrencyId: state.destinationCurrencyId,
                products: [
                    {
                        id: state.idFiadoFlash,
                        amount: state.transferredAmount
                    },
                    {
                        id: state.productId
                    }
                ]
            }

            let response = await processPayment(data, uuidv4());
            if (response?.data?.code == "PROCESS_OK") {
                setRef(response.data.data.reference)
                setCIE(response.data.data.clabe)
                const date = response.data.data.dueDate;
                Moment.locale('en');
                setDeadLine(Moment(date).format('ll'))
                //console.log(response.data.data);
            } else {
              Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: 'Ha habido un error al procesar tu transacción, intenta de nuevo por favor',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              })
            }

        }
        nextScreen();
    }, []);

    const { formatWithCurrencyISO } = useCurrencyFormat();
    //const { BillDetail } = useRequest();

  const arrayCategory3 = [
    {
      name: "7 Eleven",
      imageUrl: require("../../components/assets/images/7-eleven_logo.png"),
      km: "2km",
    },
    {
      name: "Waltmart",
      imageUrl: require("../../components/assets/images/waltmart.png"),
      km: "3.7km",
    },
    {
      name: "Superama",
      imageUrl: require("../../components/assets/images/superama.png"),
      km: "7.1km",
    },
    {
      name: "7 Eleven",
      imageUrl: require("../../components/assets/images/7-eleven_logo.png"),
      km: "2km",
    },
    {
      name: "Waltmart",
      imageUrl: require("../../components/assets/images/waltmart.png"),
      km: "3.7km",
    },
    {
      name: "Superama",
      imageUrl: require("../../components/assets/images/superama.png"),
      km: "7.1km",
    },
  ];

  return (
    <>
      <div className="max-w-7xl mx-auto px-0 sm:px-6 md:px-8">
        <div className="py-4 border-0 border-dashed sm:p-3 max-h-screen mb-5">
          <div className="border-0 text-center grid grid-cols-1 justify-items-center">
            <div className="border-0 w-full rounded-2xl grid grid-cols-1 px-10 py-5">
              <div className="border-0 col-span-1 text-Secondary font-bold text-2xl">
              {`${formatWithCurrencyISO(state.transferredAmount, state.originCurrency)}`}
              </div>
              <div className="border-0 col-span-1 text-2xl font-bold pt-8">
                Convenio / CIE:
              </div>
              <div className="border-0 col-span-1 text-xl">{cie}</div>
              <div className="border-0 col-span-1 text-2xl font-bold pt-8">
                Referencia:
              </div>
              <div className="border-0 col-span-1 text-xl">
                {ref}
              </div>
              <div className="border-0 col-span-1 text-2xl font-bold pt-8">
                Fecha límire de pago:
              </div>
              <div className="border-0 col-span-1 text-xl">{deadline}</div>
              <div className="border-0 col-span-1 grid items-center justify-center">
                <div className="w-72 sm:w-96">
                  <FInput type="botton" title="Finalizar" />
                </div>
              </div>
              <div className="border-0 col-span-1 text-sm font-bold pt-5 px-5">
                Puedes hacer el pago en estos establecimientos
              </div>
              <div class="flex overflow-x-auto space-x-8 w-1/1 ">
                <FQuickAccessList
                  productsShortcuts={arrayCategory3}
                  btn={false}
                />
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </>
  );
};

export default BankPaymentScreen;
